export default __webpack_public_path__ + "static/media/RFP.fb76c096.webp";